fx.ns("desktop.print", class PrintView extends shared.stage.BaseView {

    constructor(board){
        super(board);

        this.vmargin = 100;
        this.spaceAfterPage = 100;
        this.spaceBeforeButton = 150;
    }

    update(animate) 
    {
        let sideMargin = 25;
        let screenWidth = (this.board.realWidth - 2*sideMargin - 80);
        let childWidth = 290;
        let actionWidth = 30;
        
        let numberElementsPerLine =  Math.floor( screenWidth / (childWidth + actionWidth) );
        
        while(numberElementsPerLine < 2)
        {
            childWidth -= 10;
            numberElementsPerLine =  Math.floor( screenWidth / (childWidth + actionWidth) );
        }

        let marginOffset = (screenWidth - (numberElementsPerLine * (childWidth + actionWidth))) / 2;

        
        let childs = this.board.allChilds;

        let numElementOnCurrentline = 1, 
            childXPos = 0, 
            childYPos = 0, 
            yPos = this.vmargin, 
            childScale = 1, previousPage;

        for (let i = 0; i < childs.length; i++) 
        {
            let child = childs[i];
            
            child.show();

            if (child instanceof shared.stage.PrintArea)
            {
                childScale = childWidth / child.width();

                if (numElementOnCurrentline > numberElementsPerLine)
                {
                    numElementOnCurrentline = 1;
                    yPos += child.realHeight *  childScale  +this.spaceAfterPage;
                }

                childXPos = sideMargin/ childScale + marginOffset/ childScale + ( (numElementOnCurrentline-1) * (child.realWidth + actionWidth/ childScale));
                childYPos = yPos / childScale;
                previousPage = child;
            
                child.addClass("movable");
            }   
            else if (child instanceof fx.components.Button) 
            {
                if (typeof child.vertical == "function")
                    child.vertical(actionWidth, previousPage.realHeight*childScale);

                childXPos = (screenWidth-childWidth)/2 ;
                childYPos = yPos + (previousPage ? previousPage.realHeight*childScale : 0) +this.spaceBeforeButton;
                childScale = 1;
            }
            else if (child instanceof fx.components.Card)
            {
                if (typeof child.vertical == "function")
                    child.vertical(actionWidth, previousPage.realHeight*childScale);

                childXPos = (screenWidth-childWidth)/2 ;
                childYPos = yPos + (previousPage ? previousPage.realHeight*childScale : 0);
                childScale = 1;
            }
            
            if(!(child instanceof fx.components.Text))
                numElementOnCurrentline++;
                
            this.applyPosition(child, { scale : childScale, x : childXPos, y :  childYPos }, (child instanceof shared.stage.PrintArea));
        }

        this.delay(this.scroll, animate ? 250 : 0);
    }

    select(area, animate)
    {
        let position = this.getPosition(area);
        let yPos = (position.y * position.scale) - (this.board.realHeight - area.realHeight*position.scale) / 2;

        this.board.scrollableContent.scroll( yPos, animate, "vertical");
    }

    scroll()
    {
        let viewPort = { top : this.board.scrollPosition, bottom : this.board.scrollPosition  + this.board.realHeight };
        this._areas = [];

        for (let i = 0; i < this.board._editableAreas.length; i++)
        {
            let area = this.board._editableAreas[i];

            if (area.dragActive)
                continue;

            let position = this.getPosition( area );
            
            if (!position)
                continue;
                
            let load = !( position.y*position.scale  > viewPort.bottom  || (position.y*position.scale + fx.dom.height(area.node) * position.scale) < viewPort.top );
            this._areas.push({area : area, load : load});
        }

        this.delay(this._loadUnload, 50);
    }

    _loadUnload()
    {
        for (let i = 0; i < this._areas.length; i++)
        {
            let item = this._areas.getItemAt(i);
            if (item.load)
                item.area.load();
            else
                item.area.unload();
        }

    }

});
